import { useContext, useEffect, useState } from "react";
import { AuthType } from "../../shared/constants/AppEnums";
import { defaultUser } from "../../shared/constants/AppConst";
import jwtAxios from "../services/ApiConfig";
import { AuthUser } from "../../types/models/AuthUser";
import {
  fetchStart,
  fetchSuccess,
  useInfoViewActionsContext,
} from "../core/InfoView/InfoViewContext";
import AppContext from "./AppContext";
import AppContextPropsType from "../../types/AppContextPropsType";

export const useAuthToken = (): [boolean, AuthUser | null] => {
  const [loading, setLoading] = useState(true);
  const { user, updateAuthUser } = useContext<AppContextPropsType>(AppContext);
  const dispatch = useInfoViewActionsContext()!;

  useEffect(() => {
    const validateAuth = async () => {
      dispatch(fetchStart());
      let practitionerDetails = localStorage.getItem("PractitionerDetails");
      let token = "";
      let userdetails: any;
      if (practitionerDetails) {
        userdetails = JSON.parse(practitionerDetails);
        token = userdetails["identificationKey"];
      }

      //  let token = userdetails['identificationKey'];

      // localStorage.setItem("PractitionerDetails", JSON.stringify(response.data.details));

      // console.log("token::", token);
      if (!token) {
        dispatch(fetchSuccess());
        return;
      }
      // console.log("token1::", token);
      jwtAxios.defaults.headers.common["x-auth-token"] = token;
      try {
        // console.log("token2::", token);
        //const res = await jwtAxios.get('/auth');
        // console.log("token3::", token);
        //  dispatch(fetchSuccess());
        updateAuthUser({
          authType: AuthType.JWT_AUTH,
          displayName: userdetails["firstName"],
          email: userdetails["email"],
          role: ["user", "admin"],
          token: token,
          uid: userdetails["docid"],
          photoURL: userdetails["photo"],
        });
        return;
      } catch (err) {
        //  dispatch(fetchSuccess());
        return;
      }
    };

    const checkAuth = () => {
      Promise.all([validateAuth()]).then(() => {
        setLoading(false);
      });
    };
    checkAuth();
  }, [dispatch, updateAuthUser]);

  return [loading, user];
};

export const useAuthUser = (): AuthUser | null => {
  const { user } = useContext<AppContextPropsType>(AppContext);
  if (user) {
    return user;
  }
  return null;
};

export const getUserToken = () => {
  let practitionerDetails = localStorage.getItem("PractitionerDetails");
  let token = "";
  let userdetails: any;
  if (practitionerDetails) {
    userdetails = JSON.parse(practitionerDetails);
    token = userdetails["identificationKey"];
  }

  return token;
};

export const getUserName = () => {
  let PractDetails = localStorage.getItem("PractitionerDetails");
  let userName = "";
  let userdetails: any;
  if (PractDetails) {
    userdetails = JSON.parse(PractDetails);
    userName = userdetails["firstName"] + " " + userdetails["lastName"];
  }

  return userName;
};
export const getUserEmail = () => {
  let PractDetails = localStorage.getItem("PractitionerDetails");
  let email = "";
  let userdetails: any;
  if (PractDetails) {
    userdetails = JSON.parse(PractDetails);
    email = userdetails["email"];
  }

  return email;
};

export const getUserId = () => {
  let PractDetails = localStorage.getItem("PractitionerDetails");
  if (PractDetails) {
    const details = JSON.parse(PractDetails);
    return details.identificationKey || details.id || details.docid || "";
  }
  return "";
};
